import {Flash, Link} from '@primer/react'
import type {HeaderResponse} from '../types'

export type AdvisoryWorkspaceHeaderProps = Pick<HeaderResponse, 'repo' | 'advisoryInfo'>

export function AdvisoryWorkspaceHeader({repo, advisoryInfo}: AdvisoryWorkspaceHeaderProps) {
  if (!repo.isAdvisoryWorkspace || !advisoryInfo) {
    return null
  }

  return (
    <Flash variant="warning" className="tmp-mt-3">
      This repository is a temporary private fork for the{' '}
      <Link inline href={advisoryInfo.url}>
        {advisoryInfo.ghsaId}
      </Link>{' '}
      security advisory.
    </Flash>
  )
}
